import {
  apiRequest,
  pensiunCreate,
  masterEmployee,
  masterType,
  masterRetiredDocument,
  pensiunGetFolderList,
  pensiunGetDocument,
} from "../../../../../services/adapters/kepegawaian/pensiunService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      pensiunCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      masterEmployee,
      {
        params: query,
      },
      true
    );
  };

  fetchType = async (query) => {
    return await apiRequest(
      "get",
      masterType,
      {
        params: query,
      },
      true
    );
  };

  fetchTypeStop = async (query) => {
    return await apiRequest(
      "get",
      masterType,
      {
        params: query,
      },
      true
    );
  };

  fetchDocument = async (query) => {
    return await apiRequest(
      "get",
      masterRetiredDocument,
      {
        params: query,
      },
      true
    );
  };

  fetchDMSList = async (query) => {
    return await apiRequest(
      "get",
      pensiunGetFolderList,
      {
        params: query,
      },
      true
    );
  };

  fetchDocumentList = async (query) => {
    return await apiRequest(
      "get",
      pensiunGetDocument,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
